import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import ReferralGroup from './ReferralGroup';

const ReferralList = ({ ...props }) => {
  let sortedReferrals = _.get(props, 'referrals', []);
  let mostRecentReferrals = [];
  if (!props.searchHasValue) {
    mostRecentReferrals = sortedReferrals.slice(0, 10);
    sortedReferrals = sortedReferrals.filter((referral) => mostRecentReferrals.find(item => item.contactKey === referral.contactKey) === undefined);
  }
  return (
    <React.Fragment>
      {
        !props.searchHasValue &&
        <ReferralGroup referralGroup={mostRecentReferrals} selectRefferal={props.selectRefferal} groupName='Top 10 Recent' currentReferralFilter={props.currentReferralFilter} />
      }
      {
        (props.searchHasValue || sortedReferrals.length > 0) &&
        <ReferralGroup referralGroup={sortedReferrals} selectRefferal={props.selectRefferal} groupName='Referrals (A-Z)' currentReferralFilter={props.currentReferralFilter} />
      }
    </React.Fragment>
  );
};

ReferralList.propTypes = {
  referrals: PropTypes.array.isRequired,
  selectRefferal: PropTypes.func,
  searchHasValue: PropTypes.bool,
  currentReferralFilter: PropTypes.string
};

export default ReferralList;
